export default "__VITE_ASSET__1ryHinf1__"